/* eslint-disable tailwindcss/no-custom-classname */
import Link from "next/link";
import React, { FC } from "react";

import { NEXT_URL } from "@/utils/const";

import LogoImg from "/public/logo.svg";
import ArrowRightWhiteIcon from "/public/icon/arrow_right_white.svg";

interface Props {
  isSticky: boolean;
  stickyRef: React.RefObject<HTMLDivElement>;
}

export const SpAdvertisementFooter: FC<Props> = ({
  isSticky,
  stickyRef,
}: Props) => {
  return (
    <>
      <div
        className={`w-full bg-[#ECFAF7] border-t border-[#D9F4F0] space-y-3 p-3 pt-4 mt-5`}
      >
        <div className="space-y-1.5 text-center">
          <div className="flex items-center justify-center w-fit gap-x-1 mx-auto">
            <LogoImg width="95" height="18" title="Yoyacoo" />
            <span className="text-[#4C4C4C] text-[10px] font-bold leading-normal tracking-normal">
              なら
            </span>
          </div>
          <div
            className="text-[#4C4C4C] text-xs font-bold leading-loose tracking-normal"
            ref={stickyRef}
          >
            魅力的な申込ページをカンタン作成！
            <p className="text-[#2EAB97] text-base">
              予約、決済、メルマガ、フォーム
            </p>
            すべて自動化・ラクラク管理
          </div>
        </div>
        <Link
          href={NEXT_URL.SYSTEM_LP_REFERRAL}
          className="flex justify-center items-center w-full gap-x-2 bg-[#2EAB97] rounded-sm py-2 pl-5 pr-4">

          <span className="text-white text-xs font-bold leading-loose">
            今すぐ無料でページを作成する
          </span>
          <ArrowRightWhiteIcon />

        </Link>
      </div>
      <div
        className={`fixed w-full bg-[#ECFAF7] border-y border-[#D9F4F0] z-[100] ${
          isSticky ? "bottom-0 left-0" : "bottom-[-72px] left-0"
        } transition-all`}
      >
        <div className="px-3 pl-4 pt-3 pb-[22px]">
          <div className="flex items-center justify-center">
            <LogoImg width="63" height="12" title="Yoyacoo" />
            <div className="ml-1.5 text-xs font-normal leading-normal">
              LP、予約フォーム、メルマガを作成
            </div>
          </div>
          <div className="flex items-center justify-center">
            <Link
              href={NEXT_URL.SYSTEM_LP_REFERRAL}
              className="text-[#1C8F7D] text-sm font-bold leading-normal underline underline-offset-4">
              
                ヨヤクーを無料で使ってみる
              
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
